<template>
  <div class="well page">
    <div v-if="job" id="printReview" class="row">
      <img class="hidden-xs pull-right" src="/static/imgs/logo.png"/>
      <h2>Review</h2>

      <p>This report documents the issues outlined below for your <b>{{ store.name }}</b> store.</p>
      <b v-if="job.urgent">You have chosen to have this request completed ASAP!</b>
      <p v-if="!job.urgent">You have chosen to have this request completed in <b>{{ job.urgency_days }}</b> days.</p>

      <div id="showMsg"><!-- Error messages etc are shown here --></div>

      <h3 v-show='issues.length > 0 '>Request Summary</h3>
      <div class="col-xs-12" v-for="issue in issues">
        <div class="panel panel-default">
          <div class="panel-body">
            <b>Type: {{ issue_type_name(issue.type) }}</b> <br>
            <i class="description">Description: {{ issue.description }}</i> <br>
            <div
                v-for="image in issue_images(issue)"
                style="display: inline;"
            >
              <i
                  class="glyphicon glyphicon-picture"
                  @click="view_image(image)"
                  style="cursor: pointer"
              ></i>&nbsp;
            </div>
            <br v-if="!issue_images(issue).length">
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <button @click="submit" class="btn btn-success pull-right">Submit <i
          class="glyphicon glyphicon-envelope"></i></button>
      <!-- <button print-div="#printReview" class="btn btn-primary">Print <i class="glyphicon glyphicon-print"></i></button> -->
      <a
          class="btn btn-info"
          href=""
          @click.prevent="edit_job"
      >Edit <i class="glyphicon glyphicon-pencil"></i></a>
    </div>
    <modal
        v-if="selected_photo"
        v-model="modal_open"
        title="View Issue Image"
        @hide="modal_closed"
        size="lg"
    >
      <img :src="selected_photo.image">
    </modal>
  </div>
</template>

<style scoped>
  img {
    max-width: 100%;
  }

  i.description {
    white-space: pre-line;
  }
</style>

<script>
  import {mapGetters} from "vuex"

  import find from "lodash/find"
  import filter from "lodash/filter"

  import {Modal} from "uiv"

  export default {
    async created () {
      let promises = [
        this.$store.dispatch("get_jobs", {job_id: this.$route.params.job_id, lazy: true}),
        this.$store.dispatch("get_issues", {job_id: this.$route.params.job_id}),
        this.$store.dispatch("get_issue_photos", {job_id: this.$route.params.job_id}),
        this.$store.dispatch("get_stores", true)
      ];
      await Promise.all(promises);

      this.$store.commit("select_job", this.$route.params.job_id);
      this.$store.commit("select_store", this.job.store);
    },
    data () {
      return {
        selected_photo: null,
        modal_open: false
      }
    },
    computed: mapGetters([
      "job",
      "store",
      "issues",
      "issue_photos",
      "issue_types",
    ]),
    methods: {
      edit_job () {
        this.$router.push({
          name: "job-logger",
          job_id: this.job.id
        });
      },
      issue_type_name (type) {
        let it = find(this.issue_types, {id: type});
        if (!it) {
          return "Unknown Issue Type"
        }
        return it.name;
      },
      issue_images (issue) {
        return filter(this.issue_photos, {issue: issue.id});
      },
      view_image (photo) {
        this.selected_photo = photo;
        this.modal_open = true;
      },
      modal_closed () {
        this.selected_photo = null;
      },
      async submit () {
        await this.$store.dispatch("submit_job", this.job.id);
        this.$router.push({name: "store-list"});
        this.$store.commit("add_toast", {
          message: "The job has been successfully logged.",
          time: 5,
        })
      },
    },
    components: {
      Modal
    }
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/JobReview.vue?2c7bbc40